<template>
  <a-spin
      tip="Your document is being processed, do not leave this page!"
      :spinning="loading.information"
  >
      <a-row :gutter="12">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
          <a-form class="margin-bottom" :form="form">
            <a-form-item label="Date">
              <a-date-picker
                placeholder="Select Date"
                disabled
                :format="getDefaultDateFormat"
                v-decorator="[
                  'date',
                  {rules: [{ required: true }],
                    initialValue: initialData.date,},]"
              />
            </a-form-item>
            <a-form-item label="Type of Transaction">
              <a-radio-group
                      buttonStyle="solid"
                      v-decorator="['jns_transaksi',{rules: [{ required: true }],initialValue: initialData.jns_transaksi,},]"
                      @change="handleChangeTypeTransaction1"
                      ref="site"
              >
                <a-radio-button value="po" ref="Radio1">PO</a-radio-button>
                <a-radio-button value="wo" ref="Radio2">WO</a-radio-button>
                <!-- <a-radio-button value="other_outcome" ref="Radio2">Other Outcome</a-radio-button> -->
              </a-radio-group>
            </a-form-item>
            <a-form-item label="No PO / WO" required>
              <v-select
                prepend-icon="edit"
                class="m-select"
                :clearable="false"
                @input="handleNoPoWo"
                :options="no_po_wo"
                v-model="nopowo"
                placeholder="Select No PO/WO"
                label="no_trans"
              >
                <template v-slot:prepend>
                  <a-icon color="red">edit</a-icon>
                </template>
                <!-- <template #option="{ no_trans, value_ap }"> -->
                <template #option="{ no_trans, }">
                  <div class="m-display-flex flex-row space-between">
                    <div>{{ no_trans }}</div>
                  </div>
                </template>
              </v-select>
              <!-- <div v-if="valueAP" class="m-form-description-small">Value AccountPay : {{valueAP}}</div> -->
            </a-form-item>
            <a-form-item :label="'Value Account Pay ('+
            (this.kurs_compare.currency_powo ? this.kurs_compare.currency_powo : '-')+')'">
              <a-input-number
                class="m-width-full"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-model="valueAP"
                :disabled="true"
              ></a-input-number>
            </a-form-item>
            <a-form-item label="Description">
              <a-textarea :rows="5"
                v-decorator="['description', { rules: [{ required: true }],
                initialValue: initialData.description,
                }]"
              ></a-textarea>
            </a-form-item>
            <!-- <a-form-item label="Currency">
              <a-select
                showSearch
                v-decorator="[
                  'currency',
                  {
                    rules: [{ required: true }],
                    initialValue: initialData.currency,
                  },
                ]"
                placeholder="Select Currency"
                @change="handleMataUang"
                ref="currency_entri"
              >
                <a-select-option
                  v-for="item in currencyList"
                  :key="item.value"
                  :value="item.value"
                  >{{ item.text }}</a-select-option
                >
              </a-select>
            </a-form-item>
            <a-form-item label="Account To">
              <a-select
                showSearch
                allowClear
                option-filter-prop="children"
                :filter-option="filterOption"
                  v-decorator="['account_to', { rules: [{ required: true }],
                    initialValue: initialData.account_to, }]"
                placeholder="Select Account to"
              >
                <a-select-option
                  v-for="item in accountToList"
                  :key="item.kode_rekening"
                  :value="item.value"
                >{{item.text}}</a-select-option> 
              </a-select>
            </a-form-item>
            <a-form-item label="Kurs">
              <a-input-number
                class="m-width-full"
                :formatter="
                  (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                v-decorator="[
                  'kurs',
                  {
                    rules: [{ required: true }, { validator: checkMaxValue }],
                    initialValue: initialData.kurs,
                  },
                ]"
                @change="handlechangekurs"
                :disabled="kurscomparedisabled"
              ></a-input-number>
            </a-form-item> -->
          </a-form>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" class="m-page-wrapper">
          <!-- <a-form-item label="Receive from">
            <a-input
              v-decorator="['receive_from', { rules: [{ required: true }],
              initialValue: initialData.receive_from, }]"
            ></a-input>
          </a-form-item>
          <a-form-item :label="'Value ('+(kurs_compare.currency ? kurs_compare.currency : '')+')'">
            <a-input-number
              class="m-width-full"
              :formatter="
                (value) => ` ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
              v-decorator="[
                'value',
                {
                  rules: [{ required: true }, { validator: checkMaxValue }],
                  initialValue: initialData.value,
                },
              ]"
              @change="handelConversion"
            ></a-input-number>
            <div v-if="valueConversion" class="m-form-description-small">Value Conversion : {{valueConversion}}</div>
          </a-form-item>-->
          <a-form class="margin-bottom" :form="form_document" ref="form_document">
            <a-card>
              <span slot="title">
                Document Support
              </span>
              <a-form-item label="Document Name">
                <a-input
                  v-decorator="['document_name', { rules: [{ required: true }],
                  initialValue: initialData.document_name, }]"
                ></a-input>
              </a-form-item>
              <a-form-item label="Upload File Support">
                <a-upload
                  :showUploadList="false"
                  :fileList="push"
                  :beforeUpload="beforeUpload"
                  v-decorator="['upload_file_support', { rules: [{ required: true, validator: validateUpoadFile }], 
                  valuePropName: 'push' }]"
                >
                  <a-button> <a-icon type="upload" />&nbsp;Select File + Add</a-button>
                </a-upload>
                <!-- :defaultFileList="initialData.upload_file_support" -->
              </a-form-item>
              <a-list
                bordered
                :dataSource="pushList"
                class="doc-viewer edit margin-top"
                size="small"
              >
                <a-list-item slot="renderItem" slot-scope="item, index">
                  <a-list-item-meta>
                    <div slot="description">
                      <div class="m-display-flex space-between align-middle">
                        <div><b>{{index+1}}. {{item.document_name}}</b><br/>
                        <span>{{item.file.document_name}}</span></div>
                        <a-button icon="delete" type="danger" @click="handleRemove(item.document_name)"></a-button>
                      </div>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
                <!-- <div slot="header">Header</div>
                <div slot="footer">Footer</div> -->
              </a-list>
            </a-card>
          </a-form>
        </a-col>
      </a-row>
  </a-spin>
</template>

<script>
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import _ from "lodash";

export default {
  name: "information",
  props: {
    type: String,
    dataProcessed: {},
  },
  mixins: [CurrencyFormat, GlobalMethod],
  components: {},
  data() {
    return {
      postData: new FormData(),
      push: [],
      mataUang: undefined,
      loading:{
        information: false,
        powo:false,
      },
      no_po_wo:[],
      nopowo: undefined,
      valueAP: undefined,
      valueConversion: undefined,
      currencyList: [],
      accountToList: [],
      accountToListOrigin: [],
      kurs_compare:{
        currency_powo:undefined,
        currency:undefined,
      },
      pushList: [],
    };
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getStandartFormatDate",
      "getDefaultDateFormat",
    ]),
    initialData() {
      if(this.dataProcessed.information != null){
        return {
          date : moment(this.dataProcessed.information.date),
          jns_transaksi : this.dataProcessed.information.jns_transaksi,
          account_to: this.dataProcessed.information.account_to,
          value : this.dataProcessed.information.value,
          currency : this.dataProcessed.information.currency,
          description : this.dataProcessed.information.description,
          receive_from : this.dataProcessed.information.receive_from,
          upload_file_support: this.dataProcessed.information.upload_file_support,
          kurs: this.dataProcessed.information.kurs,
        };
      }else{
        return {
          date: moment(),
          jns_transaksi: "po",
          account_to: undefined,
          value : undefined,
          currency : undefined,
          description : undefined,
          receive_from: undefined,
          upload_file_support: undefined,
          kurs: undefined,
        };
      }
    },
    kurscomparedisabled(){
      return this.kurs_compare.currency_powo == this.kurs_compare.currency;
    },
  },
  mounted() {
    //Event.$on("confirmMessageReturn", this.submit);
    if(this.dataProcessed.information != null){
      let val = {
        target :{
          value: this.dataProcessed.information.jns_transaksi
        }
      };
      this.handleChangeTypeTransaction2(val);
      this.nopowo = this.dataProcessed.information.nopowo;
      this.valueAP = this.dataProcessed.information.nopowo.value_ap;
      this.pushList = this.dataProcessed.push;
      this.handelConversion(this.dataProcessed.information.value);
      this.kurs_compare.currency = this.dataProcessed.information.currency;
      this.kurs_compare.currency_powo = this.dataProcessed.information.nopowo.currency;
    }else{
      let val = {
        target :{
          value: "po"
        }
      };
      this.handleChangeTypeTransaction2(val);
      this.nopowo = undefined;
      this.valueAP = undefined;
      this.push = [];
    }
  },
  beforeDestroy() {
    //Event.$off("confirmMessageReturn", this.submit);
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.form_document = this.$form.createForm(this);
  },
  created() {
    this.form = this.$form.createForm(this);
    this.fetchMataUang();
  },
  methods: {
    moment,
    handleChangeTypeTransaction1(val){
      this.resetpowoentri();
      this.handleJenisTransaksi(val);
      if (val.target.value=="other_outcome"){
        Event.$emit("setstepRuleDtl", false);
      }else{
        Event.$emit("setstepRuleDtl", true);
      }
    },
    handleChangeTypeTransaction2(val){
      this.handleJenisTransaksi(val);
    },
    handleJenisTransaksi(val){
      this.loading.information = true;
      this.asyncAxiosGet(
          "payment_refund/data_refund",
          this.getAuth,
          {jenis:val.target.value}
      ).then((response) => {
          //console.log("berhasil",response);
          this.no_po_wo = response.no_trans;
          this.currencyList = response.currency;
          this.accountToList = response.account_to;
          this.accountToListOrigin = response.account_to;

          this.loading.information = false;
      }).catch((err) => {
          console.log(err);
          this.loading.information = false;
      });
    },
    resetpowoentri(){
      this.valueAP = null;
      this.nopowo = null;
      this.$nextTick(function () {
          this.form.setFieldsValue({
            kurs : undefined,
            account_to: undefined,
            currency: undefined
          });
        });
    },
    handleNoPoWo(item) {
      this.valueAP = item.value_ap;
      this.kurs_compare.currency_powo = item.currency;
      this.setKurs();

      // reconversion value if not empty
      let oldval =this.form.getFieldValue("value");
      if (oldval){
        this.handelConversion(oldval);
      }
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        let nam = this.form_document.getFieldValue("document_name");
        let existAttachment =  _.filter(this.pushList, (item) => item.document_name.toLowerCase()===(nam ? nam.toLowerCase() : null));
        if(nam==null || nam=="" ){
          this.displayMessageValue("error-other", "Document Name Can't be Empty!");
        }else if (existAttachment.length>0){
          this.displayMessageValue("error-other", "Document Name is already exist!");
        }else{
          this.pushList.push({
            document_name: nam,
            file: file,
          });
          this.push=[];
          this.form_document.setFieldsValue({
            document_name: "",
          });
        }
        return false;
      }
    },
    handleRemove(name){
      this.pushList = _.filter(this.pushList, (item) => item.document_name.toLowerCase()!=name.toLowerCase());
    },
    fetchMataUang() {
      this.$store.dispatch("FETCH_ALL_MATA_UANG");
    },
    handleMataUang(kurs) {
      this.kurs_compare.currency = kurs;
      this.setKurs();
        this.accountToList = _.filter(this.accountToListOrigin,
              el => el.currency==kurs);
      this.$nextTick(function () {
        this.form.setFieldsValue({
          account_to : undefined
        });
      });
      // reconversion value if not empty
      let oldval =this.form.getFieldValue("value");
      if (oldval){
        this.handelConversion(oldval);
      }
    },
    checkMaxValue(rule, value, callback) {
      if (value <= 999999999999) {
        callback();
        return;
      }
      callback("Max. value 999.999.999.999!");
    },
    handleRef() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        if (this.nopowo==null) {
          this.displayMessageValue("error-other", "No PO / WO Can't be empty!");
          return;
        }

        if (this.pushList.length==0) {
          this.displayMessageValue("error-other", "Document Support Can't be empty!");
          return;
        }

        //conversion currency
        // let toreturn = 0;
        // if (values.currency=="IDR"){
        //   toreturn = (values.value/values.kurs).toFixed(2);
        // }else{
        //   toreturn = (values.value*values.kurs).toFixed(2);
        // }
        
        // if (parseFloat(toreturn)>parseFloat(this.nopowo.value_ap)){
        //   this.displayMessageValue("error-other", "Return of currency conversion must be same or less than Account Pay!");
        //   return;
        // }
        values.valueAP = this.valueAP
        values.nopowo = this.nopowo;
        Event.$emit("rp_infoData", {
            informasi: values,
            push : this.pushList,
            currencyList : this.currencyList,
            accountToList : this.accountToList,
        });
      });
    },
    validateUpoadFile(rule, value, callback){
      if (this.push.length > 0) {
        callback();
        return;
      }
      // uncomment untuk return false muncul
      // callback("Upload File Support is required!");
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    setKurs(){
      if(this.kurscomparedisabled)
        //this.$nextTick(function () {
          this.form.setFieldsValue({
            kurs : 1
          });
        //});
    },
    handelConversion(val){
      let currto = this.form.getFieldValue("currency");
      let kursto = this.form.getFieldValue("kurs");
      let toreturn = 0;
      if(kursto && currto && val){
        if (this.nopowo.currency!="IDR" && currto=="IDR"){
          toreturn = (val/kursto).toFixed(2);
        }else if(this.nopowo.currency=="IDR" && currto=="USD"){
          toreturn = (val*kursto).toFixed(2);
        }else{
          toreturn = (val/kursto).toFixed(2);
        }
        this.valueConversion = this.formatCurrency(this.nopowo.currency,toreturn);
      }else{
        this.valueConversion = undefined;
      } 
      
    },
    handlechangekurs(){
      // reconversion value if not empty
      let oldval =this.form.getFieldValue("value");
      if (oldval){
        this.handelConversion(oldval);
      }
    }
  },
};
</script>

<style lang="less" scoped>
</style>
